import React, { useState } from 'react';
import './Onboarding.css';

const READINESS_OPTIONS = [
    {
        id: 'spark',
        title: 'Looking for an idea',
        description: "I want to write something but haven't found my story yet."
    },
    {
        id: 'fragments',
        title: 'Fragments and pieces',
        description: "I have a character, an image, or a question — but it's not connected yet."
    },
    {
        id: 'concept',
        title: 'A concept',
        description: "I can describe the basic idea, but I'm still figuring out the details."
    },
    {
        id: 'formed',
        title: 'A formed story',
        description: "I know my protagonist, conflict, and how the plot is built."
    }
];

function ReadinessSelector({ medium, onSelect }) {
    const [selected, setSelected] = useState(null);

    return (
        <div className="readiness-selector">
            <h2>What do you have so far?</h2>
            <p className="readiness-selector__subtitle">This helps me know how to start our conversation.</p>

            <div className="readiness-options">
                {READINESS_OPTIONS.map(option => (
                    <button
                        key={option.id}
                        className={`readiness-option ${selected === option.id ? 'selected' : ''}`}
                        onClick={() => setSelected(option.id)}
                    >
                        <span className="readiness-option__title">{option.title}</span>
                        <span className="readiness-option__description">{option.description}</span>
                    </button>
                ))}
            </div>

            <button
                className="readiness-selector__button"
                onClick={() => onSelect(selected)}
                disabled={!selected}
            >
                Continue
            </button>
        </div>
    );
}

export default ReadinessSelector;
